export const enviroment = {
  apiUrlEcommerce: 'http://localhost:8000/nueva-base/ecommerce/',
  // apiUrl: 'https://api.sneakerstore.com.mx/api/',
  apiUrl: 'http://localhost:8000/api/',
  paymentUrl: 'http://payment.sneakerstore.com.mx',
  // paymentUrl: 'http://localhost:8001'
};
